<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-7 col-sm-12 col-xs-12">
                        <h4 class="card-title">Профили</h4>
                    </div>
                    <div class="col-md-5 col-sm-12 col-xs-12 text-right">
                        <button
                                (click)="openCreateModal($event)"
                                type="button"
                                class="btn btn-success btn-sm mr-2">
                            <i class="ti-plus"></i>
                            {{ 'create_profile' | localise }}
                        </button>
                        <button
                                (click)="openRecoveryModal($event)"
                                type="button"
                                class="btn btn-warning btn-sm">
                            <i class="ti-user"></i>
                            Възстановяване
                        </button>
                    </div>
                </div>

                <div class="row" style="padding-top: 15px;">
                    <div class="col-12">
                        <div class="table-responsive">
                            <table datatable [dtOptions]="dtOptions" class="table">
                                <thead>
                                <tr class="bg-primary text-white">
                                    <th>#</th>
                                    <th>{{ 'profile_finished' | localise }}</th>
                                    <th>{{ 'profile' | localise }}</th>
                                    <th>{{ 'email_or_name' | localise }}</th>
                                    <th>Изпратен E-Mail</th>
                                    <th>{{ 'just_settings' | localise }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="row-profile" *ngFor="let profile of profiles; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td class="master-ready-profile-td" (click)="changeMasterReadyProfile(profile, i)">
                                        <i *ngIf="profile.master_profile_status === 'NOT_READY'" class="times fa fa-times-circle"></i>
                                        <i *ngIf="profile.master_profile_status === 'PENDING'" class="pending fa fa-tasks"></i>
                                        <i *ngIf="profile.master_profile_status === 'READY'" class="check fa fa-check-circle"></i>
                                        <i class="edit fa fa-pencil"></i>
                                    </td>
                                    <td>{{ profile.first_name + ' ' + profile.last_name}}</td>
                                    <td>{{ profile.email }}</td>
                                    <td>
                                        {{ (getEmailSentInfo(profile.id) ? getEmailSentInfo(profile.id) : '-') }}
                                    </td>

                                    <td>
                                        <button
                                                (click)="openUserMeals(profile.id)"
                                                type="button"
                                                class="btn-meals btn btn-sm btn-primary btn-icon-text">
                                            <i class="ti-apple btn-icon-prepend"></i>
                                            {{ 'hraneniq' | localise }}
                                        </button>

                                        <button
                                                (click)="router.navigate(['master/profiles/settings', profile.id])"
                                                type="button"
                                                class="btn-settings btn btn-sm btn-secondary btn-icon-text">
                                            <i class="ti-settings btn-icon-prepend"></i>
                                            {{ 'just_settings' | localise }}
                                        </button>


                                        <i class="icon-options-vertical"
                                           style="font-size: 1.8rem; margin-left: 5px; color: #d89d03; cursor: pointer;"
                                           [app-popup]="{
                                  templateRef: actionMoreButtons,
                                  position: 'bottom',
                                  arrowPosition: ['top', 'right'],
                                  paddingless: true,
                                  closeUponSelection: true
                                }"></i>
                                        <ng-template #actionMoreButtons>
                                            <a class="dropdown-item preview-item" (click)="sendLoginDetails(profile)">
                                                <div class="preview-thumbnail">
                                                    <div class="responsive-flex-wrapper">
                                                        <i class="ti-unlock text-primary"></i>
                                                    </div>
                                                </div>
                                                <div class="preview-item-content">{{ 'send_login_info' | localise }}</div>
                                            </a>

                                            <a class="dropdown-item preview-item" (click)="router.navigate(['master/profiles/subscriptions', profile.id])">
                                                <div class="preview-thumbnail">
                                                    <div class="responsive-flex-wrapper">
                                                        <i class="ti-lock text-primary"></i>
                                                    </div>
                                                </div>
                                                <div class="preview-item-content">{{ 'access' | localise }}</div>
                                            </a>

                                            <a class="dropdown-item preview-item" (click)="router.navigate(['master/profiles/notes', profile.id])">
                                                <div class="preview-thumbnail">
                                                    <div class="responsive-flex-wrapper">
                                                        <i class="ti-notepad text-primary"></i>
                                                    </div>
                                                </div>
                                                <div class="preview-item-content">{{ 'notes' | localise }}</div>
                                            </a>

                                            <a class="dropdown-item preview-item" (click)="openMessages(profile.id)">
                                                <div class="preview-thumbnail">
                                                    <div class="responsive-flex-wrapper">
                                                        <i class="fa fa-wechat text-primary"></i>
                                                    </div>
                                                </div>
                                                <div class="preview-item-content">{{ 'messages' | localise }}</div>
                                            </a>

                                            <a class="dropdown-item preview-item" (click)="router.navigate(['master/nutrients', profile.id])">
                                                <div class="preview-thumbnail">
                                                    <div class="responsive-flex-wrapper">
                                                        <i class="fa fa-apple text-primary"></i>
                                                    </div>
                                                </div>
                                                <div class="preview-item-content">{{ 'nutrients' | localise }}</div>
                                            </a>
                                        </ng-template>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
